
import { Database } from './database';
import { M_SERVICE_INFO } from './../models/M_SERVICE_INFO';

import { Injectable } from '@angular/core';
// import { Http } from '@angular/http';
import 'rxjs/add/operator/map';



/*
  Generated class for the BllServisBilgisi provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class BllServisBilgisi extends Database {

  constructor() {
    super("M_SERVICE_INFO");

  }

  servisBilgisiGuncelle(guncellenecekElement:M_SERVICE_INFO){
    return new Promise((res,err)=>{
      this.execRawQueryWithParams("update M_SERVICE_INFO set ADRES = ? where ID = ?",[guncellenecekElement.ADRES,guncellenecekElement.ID]).then(a=>{
        res(a);
      }).catch(x=>{
        err(x);
      })
    })
  }



}



// WEBPACK FOOTER //
// ./src/providers/bll-servis-bilgisi.ts